/**
 * Centralized lucide-icon presets so icons look consistent across the CRM.
 * Spread a size preset onto an icon: <Pencil {...iconProps.sm} />.
 *
 * The CRM uses a lighter stroke than the lucide default (2). Pick a weight by
 * how prominent the icon should be, overriding the preset when needed:
 *   <Check {...iconProps.sm} strokeWidth={iconStroke.bold} />
 */
export const iconStroke = {
  thin: 1,
  regular: 1.25,
  bold: 2,
} as const

/** Stroke only — for icons whose size is set by the parent (e.g. the ui-kit Button forces [&_svg]:size-4). */
export const commonIconProps = { strokeWidth: iconStroke.regular }

/** Size + regular stroke, ready to spread on standalone icons. */
export const iconProps = {
  xs: { className: 'size-3', strokeWidth: iconStroke.regular },
  sm: { className: 'size-4', strokeWidth: iconStroke.regular },
  md: { className: 'size-5', strokeWidth: iconStroke.regular },
  lg: { className: 'size-6', strokeWidth: iconStroke.regular },
} as const
